// extracted by mini-css-extract-plugin
export default {"navyButton":"navy_navyButton__jQOsY"};